import * as React from 'react';
import { CSSObject } from 'styled-components';
import { config, animated, useSpring, SpringConfig } from 'react-spring';

type Props = {
  children: React.ReactElement;
  config?: SpringConfig;
  delay?: number;
  from?: 'left' | 'right' | 'top' | 'bottom';
  immediate?: boolean;
  style?: CSSObject;
};

const defaultConfig = {
  mass: 20,
  tension: 500,
  friction: 180,
  precision: 0,
};

const SlideTo: React.FC<Props> = ({
  children,
  config: springConfig = defaultConfig,
  delay = 0,
  from = 'left',
  immediate = false,
  style,
}) => {
  const x = from === 'left' ? '-30px' : from === 'right' ? '30px' : '0';
  const y = from === 'top' ? '-30px' : from === 'bottom' ? '30px' : '0';
  const transformFrom = `translate3d(${x}, ${y}, 0)`;
  const props = useSpring({
    from: { opacity: 0, transform: transformFrom },
    to: { opacity: 1, transform: 'translate3d(0, 0, 0)' },
    config: (property) =>
      property === 'transform' ? config.molasses : springConfig,
    delay,
    immediate,
  });

  return (
    <>
      <animated.div style={{ ...props, width: '100%', ...style }}>
        {children}
      </animated.div>
    </>
  );
};

export default SlideTo;
